
import useFetchData from '../../../hooks/useFetchData';
import PropTypes from 'prop-types';
import TableComponent from '../../TableComponent';
import usePostData from '../../../hooks/usePostData';
import closeIcon from '../../../assets/images/close.png';
import { ReactComponent as EyeIcon } from '../../../assets/images/eye.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/edit.svg';
import { ReactComponent as UploadIcon } from '../../../assets/images/upload-file.svg';
import { ReactComponent as PDFIcon } from '../../../assets/images/pdf.svg';
import { ReactComponent as ExcelIcon } from '../../../assets/images/excel.svg';
import moment from 'moment';
import config from '../../../config';
import Api from '../../../utils/api';
import translating from '../translate.json';
import { useContext, useEffect, useState } from 'react';
import BasicPopover from 'components/Popover';
import Upload, { Upload2, UploadBasic } from 'components/Upload';
import GlobalContext from 'contexts';
import { Table, TableCell, TableHead, TableRow } from '@mui/material';
import eProductType from 'enums/enum-product-type';
import ClientProductFiles from './ClientProductFiles';

const Reports = ({ clientProductId, handleChangeMode }) => {
  const { postData, res, payload } = usePostData();
  const {
    postData: downloadPDF,
    res: downloadPDFRes,
    error: downloadPDFError,
  } = usePostData();

  const [showMessage, setShowMessage] = useState(false);
  const {
    setClientProductStageId,
    setCurrentProduct,
    currentProduct,
    setGlobalProductInfo,
    globalProductInfo,
  } = useContext(GlobalContext);
  let { data: productInfo } = useFetchData(
    'client-product-stage',
    currentProduct?.client_product_uuid || clientProductId
  );
  useEffect(() => {
    if (productInfo?.length) {
      let tmp = JSON.parse(JSON.stringify(productInfo));
      tmp.sort(
        (a, b) => a.productStage.orderNumber - b.productStage.orderNumber
      );
      setGlobalProductInfo(tmp);
    }
  }, [productInfo]);

  // Fetch client product files - removed, moved to ClientProductFiles component

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const headers = [
    translating.fileName,
    translating.dateUpdated,
    translating.status,
    '',
    '',
  ];

  const actionsRequired = {
    טופס: ['view'],
    שאלון: ['edit', 'pdf'],
    מעבדה: ['view', 'edit', 'upload', 'pdf', 'excel'],
  };

  const handleViewFile = async (cp) => {
    const type = cp.productStage.type;
    const name = cp.productStage.name;
    const fileName = cp?.fileName;
    switch (type) {
      case 'טופס':
        if (name) {
          const pdfPage = `api/client-product/client/GetAgreement?AgreementType=${name}${
            fileName ? '&AgreementFileName=' + fileName : ''
          }`;
          window.open(config.url + pdfPage, '_blank');
        }
        break;
      case 'מעבדה':
        if (fileName) {
          const pdfPage = `api/client-product/file/bloodResultPdf/${fileName}`;
          window.open(config.url + pdfPage, '_blank');
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (downloadPDFError) alert('קובץ לא קיים');
    else if (downloadPDFRes) downloadPDFDile();
  }, [downloadPDFRes, downloadPDFError]);

  const handleDownloadPDFDile = (cp) => {
    const clientProductUuid =
      cp.clientProduct?.client_product_uuid ||
      currentProduct?.client_product_uuid;
    if (cp.productStage.name === 'סיכום רופא') {
      if (getProductType(cp.clientProduct) == eProductType.prediabetes) {
        window.open(
          config.url +
            `api/client-prediabetes-measures/GetReportPdf/file/${clientProductUuid}`,
          '_blank'
        );
        return;
      } else if (getProductType(cp.clientProduct) == eProductType.survey) {
        window.open(
          config.url +
            `api/client-survey-measures/GetReportPdf/file/${clientProductUuid}`,
          '_blank'
        );
        return;
      }
    } else
      downloadPDF(
        `report-text/GetReportPdf/file/${clientProductUuid}`,
        null,
        'get'
      );
  };

  const downloadPDFDile = () => {
    window.open(
      config.url +
        `api/report-text/GetReportPdf/file/${currentProduct.client_product_uuid}`,
      '_blank'
    );
  };

  const handleDownloadExelFile = (cp) => {
    if (cp.productStage.name === 'סיכום רופא') return;
    window.open(
      config.url +
        `api/report-text/GetReportXLSX/file/${currentProduct.client_product_uuid}`,
      '_blank'
    );
  };

  const bloodTestProductStage = productInfo?.find(
    (i) => i.productStage.name === 'בדיקת דם'
  );
  const hasBloodTestFile = bloodTestProductStage?.fileName ? true : false;
  const getProductType = (cp) => {
    return cp.product.parentId === 0 ? cp.product.id : cp.product.parentId;
  };
  const columns = [
    { name: 'productStage', subField: 'name' },
    { name: 'lastUpdated', format: 'date' },
    { name: 'status' },
    {
      name: 'status',
      format: 'Checkbox',
      handleChange: (data) => updateApprovedVal(data),
    },
    {
      icon: true,
      actionsRequired: actionsRequired,
      format: 'actionsRequired',
      name: 'productStage',
      subField: 'type',
      actions: [
        {
          name: 'upload',
          icon: UploadIcon,
          handleClick: (cp, e) => setAnchorEl(e.currentTarget),
        },
        {
          isBloodTestAction: true,
          hasBloodTestFile: hasBloodTestFile,
          name: 'view',
          icon: EyeIcon,
          handleClick: (cp) => {
            handleViewFile(cp);
          },
        },
        {
          name: 'edit',
          icon: EditIcon,
          handleClick: (cp) => {
            setClientProductStageId(cp?.id);
            setCurrentProduct(cp);

            if (cp?.productStage?.type === 'מעבדה') {
              setCurrentProduct(cp);
              if (getProductType(cp.clientProduct) === eProductType.genetic)
                handleChangeMode('bloodTest');
            } else if (cp?.productStage?.type === 'שאלון') {
              setClientProductStageId(cp?.id);
              if (getProductType(cp.clientProduct) === eProductType.survey) {
                if (cp?.productStage?.name === 'סיכום רופא')
                  handleChangeMode('surveySummery');
                else if (cp?.productStage?.name === 'מדדים')
                  handleChangeMode('surveyMeasures');
                else handleChangeMode('questionnaires');
              } else if (
                getProductType(cp.clientProduct) === eProductType.prediabetes
              ) {
                if (cp?.productStage?.name === 'סיכום רופא')
                  handleChangeMode('prediebetesSummery');
                else if (cp?.productStage?.name === 'מדדים')
                  handleChangeMode('prediebetesMeasures');
                else handleChangeMode('questionnaires');
              } else if (cp?.id) {
                handleChangeMode('questionnaires');
              }
            }
          },
        },
        {
          name: 'pdf',
          type: 'pdf',
          icon: PDFIcon,
          handleClick: (cp) => handleDownloadPDFDile(cp),
        },
        {
          name: 'pdf',
          type: 'excel',
          icon: ExcelIcon,
          handleClick: (cp) => handleDownloadExelFile(cp),
        },
      ],
    },
  ];

  useEffect(() => {
    if (res && res.affected === 1 && payload) {
      console.log('updated');
      window.location.reload();
    }
  }, [res, payload]);

  const updateApprovedVal = (data) => {
    data.approved = true;
    data.status = 'הסתיים';
    postData(`client-product-stage/${data.id}`, data, 'patch');
  };

  const handleSaveFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('clientProductUuid', currentProduct.client_product_uuid);
    formData.append('fileName', file.name);
    Api.post('/client-product/file/uploadedBloodResultPdfFile', formData).then(
      (res) => {
        if (res?.data?.affected == 1) {
          setTimeout(() => {
            setShowMessage(false);
            setAnchorEl(null);
          }, 3000);
          setShowMessage(true);
        }
      }
    );
  };

  const productWithDeliveryInfo = productInfo?.find(
    (p) => p.deliveryResponse && p.deliveryDate
  );
  const { deliveryResponse, deliveryDate } = productWithDeliveryInfo || {
    deliveryResponse: null,
    deliveryDate: null,
  };

  return (
    <div className="medical-info-snapshot">
      {globalProductInfo && (
        <TableComponent
          headers={headers}
          columns={columns}
          rows={globalProductInfo}
        />
      )}

      <ClientProductFiles
        clientProductId={clientProductId}
        clientProductUuid={currentProduct?.client_product_uuid}
      />

      <BasicPopover
        anchorEl={anchorEl}
        handleClose={handleClose}
        showMessage={showMessage}
      >
        <div className="popover-container">
          <img
            className="close"
            src={closeIcon}
            alt={'close popover'}
            onClick={handleClose}
          />
          <Upload handleSaveFile={handleSaveFile}></Upload>
          {showMessage && (
            <div className="succsses-msg">{translating.succsses}</div>
          )}
        </div>
      </BasicPopover>
      {currentProduct?.genResultsDate?.lastUpdated && (
        <div className="shipment-info-container">
          <div className="shipment-info-title">טעינת תוצאות גנטיות</div>
          <div>
            {moment(currentProduct.genResultsDate.lastUpdated).format(
              'DD.MM.YYYY'
            )}
          </div>
        </div>
      )}
      {currentProduct?.examerMeering?.startDate && (
        <div className="shipment-info-container">
          <div className="shipment-info-title">
            תאריך הגעת בודק רפואי-{currentProduct.examerMeering.therapistName}
          </div>
          <div>
            {moment(currentProduct.examerMeering.startDate).format(
              'DD.MM.YYYY'
            )}
          </div>
          <div>
            {moment(currentProduct.examerMeering.startDate).format('HH:mm')}
          </div>
        </div>
      )}
      {productWithDeliveryInfo && deliveryResponse && deliveryDate && (
        <div className="shipment-info-container">
          <div className="shipment-info-title">פרטי HFD</div>
          <Table classes={{ root: 'tableHeaderRoot' }}>
            <TableRow classes={{ root: 'tableBodyRowRoot' }}>
              <TableCell classes={{ root: 'tableBodyCellRoot' }}>
                {translating.deliveryDate}
              </TableCell>
              <TableCell classes={{ root: 'tableBodyCellRoot' }}>
                {deliveryDate}
              </TableCell>
            </TableRow>
            <TableRow classes={{ root: 'tableBodyRowRoot' }}>
              <TableCell classes={{ root: 'tableBodyCellRoot' }}>
                {translating.deliveryBarcode}
              </TableCell>
              <TableCell classes={{ root: 'tableBodyCellRoot' }}>
                {JSON.parse(deliveryResponse).shipmentNumber}
              </TableCell>
            </TableRow>
          </Table>
        </div>
      )}
    </div>
  );
};

export default Reports;

Reports.propTypes = {
  clientProductId: PropTypes.string,
  handleChangeMode: PropTypes.func,
};
